var __jsx = React.createElement;
import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { theme } from '@spa/offer/theme';
import PriceDetails from './PriceDetails';
import Persons from '@spa/shared/svg/persons';
import ArrowNext from '@spa/shared/svg/arrow-next';
import { getPricing } from '@spa/offer/utils/pricing';
import PiggyBankAlt from '@spa/shared/svg/piggy-bank-alt';
import Input from '@spa/shared/components/Unisystem/Input';
import Button from '@spa/shared/components/Unisystem/Button';
import { redirectToCheckout } from '@spa/shared/utils/redirect';
import Calendar from '@spa/shared/components/Unisystem/Calendar';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { isRangeValid } from '@spa/shared/utils/availabilities/range-valid';
import { formatDate, formatMoney, fromMoneyCoreFormat } from '@spa/shared/utils';
import Notifications from '@spa/shared/components/Unisystem/Calendar/notifications';
import { requestPriceDetails as _requestPriceDetails, setIsCalendarOpenAction, setPriceDetailsRequest as _setPriceDetailsRequest } from '@spa/offer/store/actions/offer';
import { changeUrlQuery, normalizeQuery, replaceFromQuery } from '@spa/shared/utils/queryParams';
import { Wrapper, PriceSection, DatesSection, Price, CalendarWrapper, OuterWrapper, ReserveWarning } from './styles';
import { trackFixedContractCancelClick, trackFixedContractConfirmClick, trackFixedContractModalOpen, trackFixedContractOptionClick, trackRequestIntention, trackRequestToBook, trackSelectDates, trackPriceReview, trackRequestToBookAmplitude } from '@spa/offer/store/actions/tracking';
import { isDoubleBooking } from '@spa/offer/utils/doubleBookings';
import { getAvailableFrom } from '@spa/shared/utils/transformers/contracts';
import { getCountryNamefromCityCode } from '@spa/shared/utils/countryCode';
var MOVE_IN_OUT_FORMAT = 'dd MMM yyyy';
var CALENDAR_SOURCES = {
  MOVE_IN: 'move in',
  MOVE_OUT: 'move out',
  SELECT_DATES: 'select dates'
};
var PricingBoxDesktop = function PricingBoxDesktop(_ref) {
  var _contract$fixed, _contract$fixed_unita, _accommodationOffer$c, _accommodationOffer$c2;
  var paidBookings = _ref.paidBookings,
    priceDetailsRequest = _ref.priceDetailsRequest,
    priceDetailsData = _ref.priceDetailsData,
    accommodationOffer = _ref.accommodationOffer,
    priceDetailsError = _ref.priceDetailsError,
    setPriceDetailsRequest = _ref.setPriceDetailsRequest,
    requestPriceDetails = _ref.requestPriceDetails,
    showDoubleBookingModal = _ref.showDoubleBookingModal,
    showPaymentSummary = _ref.showPaymentSummary,
    isLoading = _ref.isLoading,
    isCalendarOpen = _ref.isCalendarOpen,
    setIsCalendarOpen = _ref.setIsCalendarOpen,
    trackSelectDatesAction = _ref.trackSelectDatesAction,
    trackRequestIntentionAction = _ref.trackRequestIntentionAction,
    trackFixedContractModalOpenAction = _ref.trackFixedContractModalOpenAction,
    trackFixedContractOptionClickAction = _ref.trackFixedContractOptionClickAction,
    trackFixedContractConfirmClickAction = _ref.trackFixedContractConfirmClickAction,
    trackFixedContractCancelClickAction = _ref.trackFixedContractCancelClickAction,
    property = _ref.property,
    trackOpenCheckout = _ref.trackOpenCheckout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var router = useRouter();
  var _useState = useState(null),
    calendarSource = _useState[0],
    setCalendarSource = _useState[1];
  var offerId = accommodationOffer.id,
    contract = accommodationOffer.contract,
    offerGenderRestriction = accommodationOffer.restrictions.gender;
  var moveInRequest = priceDetailsRequest.moveIn,
    moveOutRequest = priceDetailsRequest.moveOut,
    optionId = priceDetailsRequest.optionId,
    guests = priceDetailsRequest.guests;
  var _ref2 = (priceDetailsData === null || priceDetailsData === void 0 ? void 0 : priceDetailsData.start_end) || {},
    moveIn = _ref2.start,
    moveOut = _ref2.end;
  var _getPricing = getPricing({
      accommodationOffer: accommodationOffer,
      priceDetailsRequest: priceDetailsRequest,
      priceDetailsData: priceDetailsData
    }),
    isAnyTypeFixed = _getPricing.isAnyTypeFixed,
    extraPriceAmount = _getPricing.extraPriceAmount,
    firstRentValue = _getPricing.firstRentValue,
    referencePrice = _getPricing.referencePrice;
  var extraPrice = extraPriceAmount ? {
    amount: extraPriceAmount,
    currency_code: referencePrice.currency_code
  } : null;
  var isInstantBooking = contract.is_instant_booking;
  var formattedFirstRentValue = firstRentValue && formatMoney(firstRentValue.amount, firstRentValue.currency_code);
  var moveInDate = moveInRequest || moveIn ? new Date(moveInRequest || moveIn) : null;
  var moveOutDate = moveOut || moveOutRequest ? new Date(moveOutRequest || moveOut) : null;
  var formattedMoveIn = moveInDate ? formatDate(moveInDate, language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var formattedMoveOut = moveOutDate ? formatDate(moveOutDate, language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var setMoveInOut = useCallback(function (moveIn, moveOut) {
    return setPriceDetailsRequest({
      moveIn: moveIn,
      moveOut: moveOut
    });
  });
  var selectFixedOption = useCallback(function (optionId) {
    setPriceDetailsRequest({
      optionId: optionId
    });
    trackFixedContractOptionClickAction(offerId);
  });
  var propertyType = property.typology.type_code,
    offerType = property.lifecycle.rent_by,
    cityCode = property.location.address.city_code,
    propertyGenderRestriction = property.restrictions.gender;
  var openCheckout = function openCheckout() {
    trackOpenCheckout(isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.start_date : moveInRequest, isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.end_date : moveOutRequest, guests, optionId, offerId, fromMoneyCoreFormat(firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.amount) || fromMoneyCoreFormat(referencePrice.amount), (firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.currency_code) || referencePrice.currency_code, getAvailableFrom(accommodationOffer), propertyType, offerType, router.query.city, getCountryNamefromCityCode(cityCode), offerGenderRestriction, propertyGenderRestriction);
    redirectToCheckout(offerId, isAnyTypeFixed ? {
      guests: guests,
      optionId: optionId
    } : {
      guests: guests,
      moveIn: moveInDate,
      moveOut: moveOutDate
    }, language);
  };
  var openCheckoutOrDoubleBookingModal = function openCheckoutOrDoubleBookingModal() {
    if (isDoubleBooking(paidBookings, moveIn, moveOut)) {
      showDoubleBookingModal({
        onRequestBookingAnyway: openCheckout
      });
      return;
    }
    openCheckout();
  };
  var onConfirmSuggested = function onConfirmSuggested(moveInSuggested, moveOutSuggested) {
    changeUrlQuery(router, {
      moveIn: moveInSuggested,
      moveOut: moveOutSuggested,
      guests: guests,
      optionId: optionId
    });
  };
  var _useState2 = useState(!isAnyTypeFixed && isRangeValid(moveIn && formatDate(moveInDate), moveOut && formatDate(moveOutDate), t, language, accommodationOffer)),
    validations = _useState2[0],
    setValidations = _useState2[1];
  useEffect(function () {
    setValidations(!isAnyTypeFixed && isRangeValid(moveIn && formatDate(moveInDate), moveOut && formatDate(moveOutDate), t, language, accommodationOffer));
  }, [moveIn, moveOut, priceDetailsRequest, language]);
  var formattedReferencePrice = formatMoney(referencePrice.amount, referencePrice.currency_code);
  var fixedContractOptions = (contract === null || contract === void 0 ? void 0 : (_contract$fixed = contract.fixed) === null || _contract$fixed === void 0 ? void 0 : _contract$fixed.options) || (contract === null || contract === void 0 ? void 0 : (_contract$fixed_unita = contract.fixed_unitary) === null || _contract$fixed_unita === void 0 ? void 0 : _contract$fixed_unita.options);
  var selectedOption = fixedContractOptions === null || fixedContractOptions === void 0 ? void 0 : fixedContractOptions.find(function (option) {
    return option.id === optionId;
  });
  var formattedStartDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.start_date ? formatDate(new Date(selectedOption.start_date), language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var formattedEndDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.end_date ? formatDate(new Date(selectedOption.end_date), language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var openCalendar = function openCalendar(source) {
    if (isAnyTypeFixed) {
      trackFixedContractModalOpenAction(offerId);
    }
    trackSelectDatesAction();
    trackRequestIntentionAction();
    setIsCalendarOpen(true);
    setCalendarSource(source);
  };
  var closeCalendar = function closeCalendar() {
    var _router$query$moveIn, _router$query$moveOut, _router$query$optionI;
    if (isAnyTypeFixed) {
      trackFixedContractCancelClickAction(offerId);
    }
    setPriceDetailsRequest({
      moveIn: (_router$query$moveIn = router.query.moveIn) !== null && _router$query$moveIn !== void 0 ? _router$query$moveIn : null,
      moveOut: (_router$query$moveOut = router.query.moveOut) !== null && _router$query$moveOut !== void 0 ? _router$query$moveOut : null,
      guests: +router.query.guests ? +router.query.guests : 1,
      optionId: (_router$query$optionI = router.query.optionId) !== null && _router$query$optionI !== void 0 ? _router$query$optionI : null
    });
    setIsCalendarOpen(false);
  };
  var onConfirm = function onConfirm(moveIn, moveOut, guests, optionId) {
    if (isAnyTypeFixed) {
      trackFixedContractConfirmClickAction(offerId);
    }
    changeUrlQuery(router, {
      moveIn: moveIn,
      moveOut: moveOut,
      guests: guests,
      optionId: optionId
    });
    closeCalendar();
  };
  var setGuests = useCallback(function (updatedGuests) {
    if (+updatedGuests === priceDetailsRequest.guests) {
      return;
    }
    setPriceDetailsRequest({
      guests: +updatedGuests
    });
  }, [guests, moveIn, moveOut, optionId]);
  useEffect(function () {
    if (!priceDetailsError) {
      return;
    }
    var _router$query = router.query,
      offerId = _router$query.offerId,
      city = _router$query.city,
      guests = _router$query.guests;
    replaceFromQuery(router, {
      offerId: offerId,
      city: city,
      guests: guests
    });
  }, [priceDetailsError]);
  useEffect(function () {
    var _normalizeQuery = normalizeQuery(router.query),
      moveIn = _normalizeQuery.moveIn,
      moveOut = _normalizeQuery.moveOut,
      guests = _normalizeQuery.guests,
      optionId = _normalizeQuery.optionId;
    var shouldRequestPriceDetails = false;
    if (moveIn && moveIn !== priceDetailsRequest.moveIn && moveOut && moveOut !== priceDetailsRequest.moveOut) {
      setMoveInOut(moveIn, moveOut);
      shouldRequestPriceDetails = true;
    }
    if (+guests && +guests !== priceDetailsRequest.guests) {
      setPriceDetailsRequest({
        guests: +guests
      });
      shouldRequestPriceDetails = true;
    }
    if (optionId && optionId !== priceDetailsRequest.optionId) {
      selectFixedOption(optionId);
      shouldRequestPriceDetails = true;
    }
    if (shouldRequestPriceDetails) {
      requestPriceDetails();
    }
  }, [router.query]);
  useEffect(function () {
    var _document;
    if (!isCalendarOpen) {
      return;
    }
    var calendar = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById('pricing-box');
    var _ref3 = (calendar === null || calendar === void 0 ? void 0 : calendar.getBoundingClientRect()) || {},
      calendarTop = _ref3.top,
      calendarBottom = _ref3.bottom;
    var shouldScrollIntoCalendar = calendarBottom > window.innerHeight || calendarTop < 0;
    if (!shouldScrollIntoCalendar) {
      return;
    }
    calendar.scrollIntoView({
      behavior: 'smooth'
    });
  }, [isCalendarOpen]);
  return __jsx(OuterWrapper, null, __jsx(Wrapper, {
    id: "pricing-box"
  }, __jsx(PriceSection, null, __jsx(Price, null, formattedFirstRentValue || formattedReferencePrice, __jsx("span", null, "/".concat(t('month')))), __jsx("span", null, __jsx(Persons, null), "".concat(guests, " ").concat(t(guests > 1 ? 'people' : 'person')))), __jsx(DatesSection, null, __jsx(Input, {
    value: isAnyTypeFixed ? formattedStartDate : formattedMoveIn,
    insideLabel: t('Move in'),
    isDisabled: isLoading,
    onClick: function onClick() {
      return openCalendar(CALENDAR_SOURCES.MOVE_IN);
    }
  }), __jsx(ArrowNext, {
    color: theme.colors.cornFlowerBlue
  }), __jsx(Input, {
    value: isAnyTypeFixed ? formattedEndDate : formattedMoveOut,
    insideLabel: t('Move out'),
    isDisabled: isLoading,
    onClick: function onClick() {
      return openCalendar(CALENDAR_SOURCES.MOVE_OUT);
    }
  })), __jsx(Notifications, {
    validations: validations,
    extraData: {
      extraPrice: extraPrice,
      isInstantBooking: isInstantBooking,
      setMoveInOut: onConfirmSuggested
    }
  }), __jsx(Button, {
    isPrimary: true,
    isLoading: isLoading,
    onClick: (moveIn && moveOut || optionId) && priceDetailsData ? openCheckoutOrDoubleBookingModal : function () {
      return openCalendar(CALENDAR_SOURCES.SELECT_DATES);
    }
  }, (moveIn && moveOut || optionId) && priceDetailsData ? t('Start booking') : t('Select dates')), Object.keys(priceDetailsData).length > 0 && __jsx(React.Fragment, null, __jsx(ReserveWarning, null, t("Don't worry - pressing this button won't charge you anything!")), __jsx(PriceDetails, {
    priceDetails: priceDetailsData,
    hasRentCollection: (_accommodationOffer$c = accommodationOffer.contract) === null || _accommodationOffer$c === void 0 ? void 0 : (_accommodationOffer$c2 = _accommodationOffer$c.rent_collection) === null || _accommodationOffer$c2 === void 0 ? void 0 : _accommodationOffer$c2.active
  }), __jsx(ReserveWarning, null, __jsx(PiggyBankAlt, null), t("If you find it cheaper elsewhere, we'll refund the difference.")), __jsx(Button, {
    isGhost: true,
    onClick: function onClick() {
      return showPaymentSummary(accommodationOffer, property, priceDetailsData);
    }
  }, t('Review price details'), " ", __jsx(ArrowNext, {
    color: theme.colors.cornFlowerBlue,
    width: 24
  }))), isCalendarOpen && __jsx(CalendarWrapper, {
    hasSelectedDates: !!moveOutDate
  }, __jsx(Calendar, {
    onClose: closeCalendar,
    accommodationOffer: accommodationOffer,
    property: property,
    priceDetailsRequest: priceDetailsRequest,
    priceDetailsData: priceDetailsData,
    setMoveInOut: setMoveInOut,
    setGuests: setGuests,
    selectFixedOption: selectFixedOption,
    onConfirm: onConfirm,
    extraPrice: extraPrice,
    isLoading: isLoading,
    source: calendarSource
  }))));
};
var mapStateToProps = function mapStateToProps(_ref4) {
  var paidBookings = _ref4.profile.paidBookings,
    _ref4$offer = _ref4.offer,
    _ref4$offer$priceDeta = _ref4$offer.priceDetails,
    isLoading = _ref4$offer$priceDeta.isLoading,
    priceDetailsRequest = _ref4$offer$priceDeta.request,
    priceDetailsData = _ref4$offer$priceDeta.data,
    _ref4$offer$priceDeta2 = _ref4$offer$priceDeta.error,
    error = _ref4$offer$priceDeta2 === void 0 ? null : _ref4$offer$priceDeta2,
    offerAggregate = _ref4$offer.offerAggregate,
    isCalendarOpen = _ref4$offer.isCalendarOpen;
  return {
    paidBookings: paidBookings,
    priceDetailsRequest: priceDetailsRequest || {},
    priceDetailsData: priceDetailsData || {},
    priceDetailsError: error,
    accommodationOffer: offerAggregate.accommodation_offer,
    isLoading: isLoading,
    isCalendarOpen: isCalendarOpen,
    property: offerAggregate.property_aggregate.property
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPriceDetailsRequest: function setPriceDetailsRequest(_ref5) {
      var guests = _ref5.guests,
        moveIn = _ref5.moveIn,
        moveOut = _ref5.moveOut,
        optionId = _ref5.optionId;
      return dispatch(_setPriceDetailsRequest({
        guests: guests,
        moveIn: moveIn,
        moveOut: moveOut,
        optionId: optionId
      }));
    },
    setIsCalendarOpen: function setIsCalendarOpen(newValue) {
      return dispatch(setIsCalendarOpenAction({
        isCalendarOpen: newValue
      }));
    },
    requestPriceDetails: function requestPriceDetails() {
      return dispatch(_requestPriceDetails());
    },
    showPaymentSummary: function showPaymentSummary(accommodationOffer, property, priceDetails) {
      dispatch(trackPriceReview({
        context: 'offer page'
      }));
      dispatch(showModalAction({
        modalId: modalIds.PAYMENT_SUMMARY,
        accommodationOffer: accommodationOffer,
        property: property,
        priceDetails: priceDetails
      }));
    },
    showDoubleBookingModal: function showDoubleBookingModal(_ref6) {
      var onRequestBookingAnyway = _ref6.onRequestBookingAnyway;
      return dispatch(showModalAction({
        modalId: modalIds.DOUBLE_BOOKING,
        onRequestBookingAnyway: onRequestBookingAnyway
      }));
    },
    trackSelectDatesAction: function trackSelectDatesAction() {
      return dispatch(trackSelectDates());
    },
    trackRequestIntentionAction: function trackRequestIntentionAction() {
      return dispatch(trackRequestIntention());
    },
    trackFixedContractModalOpenAction: function trackFixedContractModalOpenAction(offerId) {
      return dispatch(trackFixedContractModalOpen({
        offerId: offerId
      }));
    },
    trackFixedContractOptionClickAction: function trackFixedContractOptionClickAction(offerId) {
      return dispatch(trackFixedContractOptionClick({
        offerId: offerId
      }));
    },
    trackFixedContractConfirmClickAction: function trackFixedContractConfirmClickAction(offerId) {
      return dispatch(trackFixedContractConfirmClick({
        offerId: offerId
      }));
    },
    trackFixedContractCancelClickAction: function trackFixedContractCancelClickAction(offerId) {
      return dispatch(trackFixedContractCancelClick({
        offerId: offerId
      }));
    },
    trackOpenCheckout: function trackOpenCheckout(moveIn, moveOut, guests, optionId, offerId, price, currencyCode, availableFrom, propertyType, offerType, city, country, offerGenderRestriction, propertyGenderRestriction) {
      dispatch(trackRequestToBook());
      dispatch(trackRequestIntention());
      dispatch(trackRequestToBookAmplitude({
        moveIn: moveIn,
        moveOut: moveOut,
        guests: guests,
        optionId: optionId,
        offerId: offerId,
        price: price,
        currencyCode: currencyCode,
        availableFrom: availableFrom,
        propertyType: propertyType,
        offerType: offerType,
        city: city,
        country: country,
        offerGenderRestriction: offerGenderRestriction,
        propertyGenderRestriction: propertyGenderRestriction
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PricingBoxDesktop);